import React from 'react'
import { stringCompare } from '../../utils/sorters'
import List from '../../components/List'
import Button from '../../components/UI/Button'
import { useAuth } from '../../context/AuthProvider/useAuth'
import { useNavigate } from 'react-router-dom'
import {
  EditOutlined,
} from '@ant-design/icons'

export interface IPendingPayments {
  bingo_jackpot_payroll_id: string,
  id: {
    round: string,
    card: string,
    jackpot: string
  },
  device: string,
  location: string,
  prize: string,
  prize_time: string
}

function PendingPaymentsList(props: {payments: IPendingPayments[]}) {
  const {canEdit} = useAuth()
  const history = useNavigate()
  return (
    <>
      <List
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (value: IPendingPayments['id']) => <IdField {...value}/>,
            sorter: (a: IPendingPayments, b: IPendingPayments) => stringCompare(a.id.card, b.id.card),
            width: 110
          },
          {
            title: 'Device',
            dataIndex: 'device',
            key: 'device',
            render: (value: IPendingPayments['device']) => value,
            sorter: (a: IPendingPayments, b: IPendingPayments) => stringCompare(a.device, b.device),
            width: 110
          },
          {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            render: (value: IPendingPayments['location']) => value,
            sorter: (a: IPendingPayments, b: IPendingPayments) => stringCompare(a.location, b.location),
            width: 110
          },
          {
            title: 'Prize',
            dataIndex: 'prize',
            key: 'prize',
            render: (value: IPendingPayments['prize']) => value,
            sorter: (a: IPendingPayments, b: IPendingPayments) => stringCompare(a.prize, b.prize),
            width: 110
          },
          {
            title: 'Prize time',
            dataIndex: 'prize_time',
            key: 'prize_time',
            render: (value: IPendingPayments['prize_time']) => value,
            sorter: (a: IPendingPayments, b: IPendingPayments) => stringCompare(a.prize_time, b.prize_time),
            width: 110
          },
          {
            title: 'Edit',
            dataIndex: 'bingo_jackpot_payroll_id',
            key: 'bingo_jackpot_payroll_id',
            render: (value: IPendingPayments['bingo_jackpot_payroll_id'], record: IPendingPayments, index: number) => (
              <Button 
                disabled={!canEdit}
                onClick={() => history(`/jackpotspayrolls/edit/pending/${value}`)}
                type='primary'
                style={{backgroundColor: '#2fa4e7'}}
              >
                <EditOutlined id={'edit-page-' + index} style={{ fontSize: '16px', color: '#FFF' }} />
              </Button>
            ),
            width: 50
          },
        ]} 
        rows={props.payments || []}
      />
    </>
  )
}

const IdField = (props: IPendingPayments['id']) => {
  return(
    <>
      <div>ROUND: {props.round}</div>
      <div>CARD: {props.card}</div>
    </>
  )
}

export default PendingPaymentsList